import { sensorsApi } from "./client"
import type {
  PaginatedResponse,
  InsarDataset,
  InsarLocation,
  InsarMinMax,
  Group,
} from "@/types/api"
import type { Polygon } from "geojson"

export async function fetchInsarDataset(slug: string): Promise<InsarDataset> {
  return sensorsApi
    .get(`api/insar/dataset/${slug}/`, { searchParams: { page_size: 5000 } })
    .json<InsarDataset>()
}

export async function fetchInsarLocations(
  slug: string,
  options: {
    within: Polygon
    feature: string
    trackNum: string
    pageSize?: number
    signal?: AbortSignal
  },
): Promise<InsarLocation[]> {
  const response = await sensorsApi
    .get(`api/insar/dataset/${slug}/location/`, {
      searchParams: {
        within: JSON.stringify(options.within),
        feature: options.feature,
        track_num: options.trackNum,
        page_size: options.pageSize ?? 500000,
      },
      timeout: 120000,
      signal: options.signal,
    })
    .json<PaginatedResponse<InsarLocation>>()
  return response.results
}

export async function fetchInsarGroups(siteSlug: string): Promise<Group[]> {
  const response = await sensorsApi
    .get("api/insar/group/", {
      searchParams: { page_size: "5000", site: siteSlug },
    })
    .json<PaginatedResponse<Group>>()
  return response.results
}

export async function fetchInsarFeatureRanges(
  slug: string,
  feature: string,
): Promise<InsarMinMax> {
  return sensorsApi
    .get(`api/insar/dataset/${slug}/location/feature_ranges/`, {
      searchParams: { page_size: 5000, feature },
    })
    .json<InsarMinMax>()
}
